var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningTriangleOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "14px",
    viewBox: "0 0 17 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/orange triangle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Walk-in/out",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Walkin-out-Live-view-Copy-10",
    transform: "translate(-1038.000000, -702.000000)",
    fill: "#F6A14C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Past-entries",
    transform: "translate(76.000000, 579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verify",
    transform: "translate(962.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74396552,110.38 L8.74396552,106.18 L7.35603448,106.18 L7.35603448,110.38 L8.74396552,110.38 Z M8.74396552,112.9 L8.74396552,111.36 L7.35603448,111.36 L7.35603448,112.9 L8.74396552,112.9 Z M0,115 L8.05,101 L16.1,115 L0,115 Z",
    id: "orange-triangle"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangleOrange);
export default __webpack_public_path__ + "static/media/warning_triangle_orange.dca680d2a33e5fb3a0075c50892c9512.svg";
export { ForwardRef as ReactComponent };